import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { Partner } from "../../types/Types";

type UpdatePartnerDto = Partial<Partner>;

export const useSavePartner = (
  options?: UseMutationOptions<
  Partner,
    unknown,
    Partner | UpdatePartnerDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<Partner> | FormData) => {
      const isFormData = data instanceof FormData;
      
      // Determine if it's an update or create operation
      const hasId = isFormData ? data.get('id') ?? null : (data as Partial<Partner>)?.id ?? null;
      
      // Set headers for FormData
      const config = isFormData 
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/Partner/Update`), data, config)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/Partner/Create"), data, config)
          .then((res) => res.data);
      }
    },
  });
};
